import PropTypes from 'prop-types';

export const linkTicketPhrasesPropTypes = {
  buttons: PropTypes.shape({
    viewProfile: PropTypes.string.isRequired,
  }),
  errors: PropTypes.shape({
    scanCode: PropTypes.shape({
      notFound: PropTypes.string.isRequired,
    }),
    ticketId: PropTypes.shape({
      taken: PropTypes.string.isRequired,
    }),
  }),
  form: PropTypes.shape({
    helperText: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    submitButton: PropTypes.string.isRequired,
    submitButtonAlt: PropTypes.string.isRequired,
  }),
};
